import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import swal from 'sweetalert';
import LoadingBar from 'react-top-loading-bar';
import { useIsOnline } from 'react-use-is-online';
import {
    useDeletePaymentTypeMutation,
    useEditPaymentTypeMutation,
    useGetPaymentTypeByIdQuery
} from '../../Features/paymentTypes';

import {
    CreditCardIcon,
    TrashIcon,
    ArrowLeftIcon,
} from '@heroicons/react/outline';

function EditPaymentTypeView() {
    const navigate = useNavigate();
    const { type_id } = useParams();
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const [errors, setErrors] = useState({
        name: '',
    });

    const [input, setInput] = useState({});

    // FIXED: correctly get the RTK Query loading state
    const [
        create,
        { isLoading: isLoadingEditCreate }
    ] = useEditPaymentTypeMutation();

    // FIXED: correctly get the RTK Query loading state
    const [
        deleteType,
        { isLoading: isLoadingDelete }
    ] = useDeletePaymentTypeMutation();

    const {
        data,
        isLoading,
        isSuccess,
    } = useGetPaymentTypeByIdQuery(type_id);

    useEffect(() => {
        if (isLoading) {
            setProgress(80);
        }

        if (isSuccess) {
            setProgress(100);
        } else {
            setProgress(100);
        }

        if (isSuccess && data.hasOwnProperty("data")) {
            setInput(data.data);
        }

        return () => {
        };
    }, [data, create, deleteType]);

    const handleChange = (e) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value
        });
    };

    const handDelete = async (e, id) => {
        // if(!isOnline){
        //     return swal("No Internet connection",'Please check Internet connection and try again');
        // }

        if (
            window.confirm(
                "Are you sure you want to delete this payment type?"
            )
        ) {
            try {
                setProgress(80);

                const resp = await deleteType(id).unwrap();

                if (resp.hasOwnProperty('success') == true) {
                    setProgress(100);
                    return navigate(-1);
                }
            } catch (err) {
                setProgress(100);
                swal("Error", err.message, 'error');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if(!isOnline){
        //     return swal("No Internet connection",'Please check Internet connection and try again');
        // }

        try {
            setProgress(80);

            const resp = await create(input).unwrap();

            if (resp.hasOwnProperty('success') == true) {
                setProgress(100);
                navigate(-1);
            }
        } catch (err) {
            setProgress(100);

            if (err.data.hasOwnProperty('errors') == true) {
                setErrors({
                    ...errors,
                    name: err.data.errors.name,
                });
            } else if (err.data.hasOwnProperty('error') == true) {
                setInput({
                    ...input,
                    errorMassage: err.data.error
                });
            }
        }
    };

    const back = () => {
        if (!isOnline) {
            return swal(
                "No Internet connection",
                'Please check Internet connection and try again'
            );
        }

        navigate(-1);
    };

    return (
        <div className="w-full min-h-screen bg-gray-100 dark:bg-gray-950 pb-12">

            <LoadingBar
                color="#80b643"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />

            <div className="w-full px-4 sm:px-6 lg:px-8 pt-6">

                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">

                    <div className="flex items-center gap-3">

                        <div className="w-11 h-11 rounded-xl bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                            <CreditCardIcon className="w-6 h-6 text-[#80b643]" />
                        </div>

                        <div>
                            <h1 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
                                Edit Payment Type
                            </h1>

                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                Update the payment method details
                            </p>
                        </div>

                    </div>

                    <button
                        type="button"
                        onClick={back}
                        className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition"
                    >
                        <ArrowLeftIcon className="w-4 h-4" />
                        Back
                    </button>

                </div>

                {/* Loading Profile */}
                {isLoading ? (

                    <div className="max-w-3xl">

                        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm p-8">

                            <div className="flex flex-col items-center justify-center py-10">

                                <div className="w-10 h-10 border-4 border-gray-200 dark:border-gray-700 border-t-[#80b643] rounded-full animate-spin mb-4"></div>

                                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Loading payment type...
                                </p>

                                <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                                    Please wait
                                </p>

                            </div>

                        </div>

                    </div>

                ) : (

                    <div className="max-w-3xl">

                        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-sm overflow-hidden">

                            {/* Card Header */}
                            <div className="px-5 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-800">

                                <div className="flex items-center gap-3">

                                    <div className="w-9 h-9 rounded-lg bg-[#80b643]/10 dark:bg-[#80b643]/20 flex items-center justify-center">
                                        <CreditCardIcon className="w-5 h-5 text-[#80b643]" />
                                    </div>

                                    <div>
                                        <h2 className="text-sm font-semibold text-gray-900 dark:text-white">
                                            Payment Type Details
                                        </h2>

                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                            Update the name of this payment method
                                        </p>
                                    </div>

                                </div>

                            </div>

                            <form
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >

                                {/* Form Content */}
                                <div className="p-5 sm:p-6">

                                    <div className="max-w-xl">

                                        <label
                                            htmlFor="name"
                                            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                                        >
                                            Payment Type Name
                                        </label>

                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            value={input.name || ''}
                                            onChange={handleChange}
                                            placeholder="Enter payment type name"
                                            className={`w-full px-3.5 py-2.5 rounded-lg border ${
                                                errors.name
                                                    ? 'border-red-400 focus:ring-red-500'
                                                    : 'border-gray-200 dark:border-gray-700 focus:border-[#80b643]'
                                            } bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 outline-none focus:ring-2 focus:ring-[#80b643]/20 transition`}
                                        />

                                        {errors.name && (
                                            <p className="mt-1.5 text-xs text-red-600 dark:text-red-400">
                                                {errors.name}
                                            </p>
                                        )}

                                    </div>

                                </div>

                                {/* Delete Section */}
                                <div className="px-5 sm:px-6 py-5 border-t border-gray-200 dark:border-gray-800">

                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 rounded-xl border border-red-100 dark:border-red-900/40 bg-red-50/50 dark:bg-red-900/10">

                                        <div className="flex items-start gap-3">

                                            <div className="w-9 h-9 shrink-0 rounded-lg bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                                                <TrashIcon className="w-5 h-5 text-red-600 dark:text-red-400" />
                                            </div>

                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                                                    Delete Payment Type
                                                </h3>

                                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                    You can permanently delete this payment type.
                                                </p>
                                            </div>

                                        </div>

                                        <button
                                            type="button"
                                            onClick={(e) => handDelete(e, input.id)}
                                            disabled={isLoadingDelete}
                                            className={`w-full sm:w-auto px-4 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-medium transition ${
                                                isLoadingDelete
                                                    ? 'opacity-70 cursor-not-allowed'
                                                    : ''
                                            }`}
                                        >
                                            {isLoadingDelete
                                                ? 'Deleting...'
                                                : 'Delete Payment Type'
                                            }
                                        </button>

                                    </div>

                                </div>

                                {/* Footer */}
                                <div className="px-5 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-800/30">

                                    <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">

                                        <button
                                            type="button"
                                            onClick={back}
                                            disabled={isLoadingEditCreate}
                                            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            <ArrowLeftIcon className="w-4 h-4" />
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            disabled={isLoadingEditCreate}
                                            className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-[#80b643] hover:bg-[#719f3a] text-white text-sm font-medium shadow-sm transition ${
                                                isLoadingEditCreate
                                                    ? 'opacity-70 cursor-not-allowed'
                                                    : ''
                                            }`}
                                        >

                                            {isLoadingEditCreate && (
                                                <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span>
                                            )}

                                            {isLoadingEditCreate
                                                ? 'Saving...'
                                                : 'Save Changes'
                                            }

                                        </button>

                                    </div>

                                </div>

                            </form>

                        </div>

                    </div>

                )}

            </div>

        </div>
    );
}

export default EditPaymentTypeView;